import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// React Router does not restore hash scroll on initial page load: the
// browser fires its native one-shot hash scroll before the SPA has
// rendered the target element, so visitors arriving at /terms#refunds
// from an external link (Stripe business profile, footer of another
// page) land at the top of the page instead of the section. This hook
// re-runs the scroll once the target is in the DOM.
export function useScrollToHash() {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const el = document.querySelector(hash);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [hash]);
}
